import React, {ChangeEvent, useCallback, useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {useNavigate, useParams} from "react-router-dom";
import {
    GetDistricts, GetQuarters,
    GetRequestById,
    GetRequestsIconTypesList,
    GetRequestsStatusesList,
    GetRequestsTopicsList,
    onUpdateRequestField,
    selectCurrentRequest, selectDistricts, selectQuarters,
    selectRequestIconTypes,
    selectRequestPhotos,
    selectRequestStatuses,
    selectRequestTitle,
    selectRequestTopics
} from "../../store/requestsReducer";
import Header from "../Header/Header";
import {Button, Input, message, Popconfirm, Select, Spin, Switch} from 'antd';
import s from './Request.module.scss'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import MapForRequestPoint from "../MapForRequestPoint/MapForRequestPoint";
import {requestsAPI} from "../../app/api";
import TextArea from "antd/es/input/TextArea";
import ImagesModal from '../ImagesModal/ImagesModal';
import {useDropzone} from "react-dropzone";
import ImageSorter from "../ImageSorter/ImageSorter";
import avatar from './../../Dropdown.png'
import {LoadingOutlined} from "@ant-design/icons";
// Fix default marker icon
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
    iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png',
});

const Request = () => {
    const dispatch = useAppDispatch()
    const [fieldsWithError, setFieldsWithError] = React.useState(false)
    const {id} = useParams()
    const [loading, setIsLoading] = useState(false)
    const requestFields = useAppSelector(selectCurrentRequest)
    const topics = useAppSelector(selectRequestTopics)
    const statuses = useAppSelector(selectRequestStatuses)
    const iconTypes = useAppSelector(selectRequestIconTypes)
    const [isMapShown, setIsMapShown] = useState(false)
    const navigate = useNavigate()
    const requestTitle = useAppSelector(selectRequestTitle)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0)
    const fileListFromServer = useAppSelector(selectRequestPhotos)
    const districts = useAppSelector(selectDistricts)
    const quarters = useAppSelector(selectQuarters)
    const [isRequestLoading, setIsRequestLoading] = useState(true)

    const districtsOptions = [
        ...districts.map((d) => ({
            value: d.name,
            label: d.name
        }))
    ];

    const quartersOptions = [
        ...quarters.map((d) => ({
            value: d.name,
            label: d.name
        }))
    ];


    useEffect(() => {
        dispatch(GetDistricts())
        dispatch(GetQuarters())

    }, [dispatch])

    useEffect(() => {
        dispatch(GetRequestById({requestId: Number(id), withFields: true}))
            .then((res: any) => {
                // @ts-ignore
                if (res.payload.status.id === 1) {
                    dispatch(onUpdateRequestField({fieldKey: "status.id", value: 2}))
                    const allowedKeys = [
                        "title", "description", "status", "icon_type", "topic",
                        "location", "location_type", "district", "quarter", "street", "house_no",
                        "user_first_name", "user_last_name", "user_email", "user_phone", "is_active"
                    ];
                    const filteredFields = Object.fromEntries(
                        Object.entries(res.payload!!).filter(([key]) => allowedKeys.includes(key))
                    );
                    requestsAPI.updateRequest(Number(id), {
                        ...filteredFields,
                        status: 2,
                        is_active: res.payload?.is_active,
                        icon_type: res.payload?.icon_type.id,
                        topic: res.payload?.topic.id,
                        location: res.payload?.location !== null ? res.payload?.location.type === 'Point'
                                ? `POINT (${res.payload?.location.coordinates.point[0]} ${res.payload?.location.coordinates.point[1]})`
                                : res.payload?.location.type === 'Polygon'
                                    ? `POLYGON ((${res.payload?.location.coordinates.polygon[0].map(([lat, lng]: any) => `${lat} ${lng}`).join(', ')}))`
                                    : `LINESTRING (${res.payload?.location.coordinates.line.map(([lat, lng]: any) => `${lat} ${lng}`).join(', ')})`
                            : null
                    })
                        .then(() => {
                            setIsRequestLoading(false)
                        })
                }
                setIsRequestLoading(false)
                setIsMapShown(true)
            })
    }, [dispatch, id])// eslint-disable-line


    useEffect(() => {
        dispatch(GetRequestsTopicsList())
        dispatch(GetRequestsStatusesList())
        dispatch(GetRequestsIconTypesList())
    }, [dispatch])


    const topicOptions = topics.map((a: { id: number, name: string | null }) => ({
        value: a.id,
        label: a.name,
    }))

    const iconTypesOptions = iconTypes.map((a: { id: number, name: string | null }) => ({
        value: a.id,
        label: a.name,
    }))

    const statusOptions = statuses.map((a: { id: number, name: string | null }) => ({
        value: a.id,
        label: a.name,
    }))

    const onFormInputChange = (e: React.ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | boolean, fieldName: string) => {
        if(typeof e !== "boolean"){
            dispatch(onUpdateRequestField({fieldKey: fieldName, value: e.target.value}))
        }
        else {
            dispatch(onUpdateRequestField({fieldKey: fieldName, value: e}))
        }

    }

    const onFormSelectChange = (value: string, fieldName: string) => {
        dispatch(onUpdateRequestField({fieldKey: fieldName, value: value}))
    }

    const onSaveRequest = () => {
        if (
            requestFields?.title === ''
            || requestFields?.description === ''
            || requestFields?.user_first_name === ''
            || requestFields!?.icon_type.id === undefined
            || requestFields!?.topic.id === undefined
            || requestFields!?.status.id === undefined
        ) {
            setFieldsWithError(true)
        } else {
            setFieldsWithError(false)
            setIsLoading(true)
            const allowedKeys = [
                "title", "description", "status", "icon_type", "topic",
                "location", "location_type", "district", "quarter", "street", "house_no",
                "user_first_name", "user_last_name", "user_email", "user_phone", "is_active"
            ];
            const filteredFields = Object.fromEntries(
                Object.entries(requestFields!!).filter(([key]) => allowedKeys.includes(key))
            );
            requestsAPI.updateRequest(Number(id), {
                ...filteredFields,
                is_active: requestFields?.is_active,
                status: requestFields?.status.id,
                icon_type: requestFields?.icon_type.id,
                topic: requestFields?.topic.id,
                location: requestFields?.location !== null ? requestFields?.location.type === 'Point'
                        ? `POINT (${requestFields?.location.coordinates.point[0]} ${requestFields?.location.coordinates.point[1]})`
                        : requestFields?.location.type === 'Polygon'
                            ? `POLYGON ((${requestFields?.location.coordinates.polygon[0].map(([lat, lng]) => `${lat} ${lng}`).join(', ')}))`
                            : `LINESTRING (${requestFields?.location.coordinates.line.map(([lat, lng]) => `${lat} ${lng}`).join(', ')})`
                    : null
            })
                .then(() => {
                    message.success('Die Anfrage wurde erfolgreich aktualisiert')
                })
                .then(() => {
                    setTimeout(() => {
                        setIsLoading(false)
                        navigate('/')
                    }, 2000)
                })
        }
    }

    const onDeleteRequest = (id: number) => {
        requestsAPI.removeRequestById(Number(id))
            .then(() => {
                message.success('Die Anfrage wurde erfolgreich gelöscht')
            })
            .then(() => {
                setTimeout(() => {
                    navigate('/')
                }, 2000)
            })
    }

    const onImagesModalClose = () => {
        setIsModalVisible(false)
    }

    const MAX_IMAGE_SIZE_MB = 10;
    const MAX_VIDEO_SIZE_MB = 100;


    const imageTypes = ["image/jpeg", "image/png"];
    const videoTypes = ["video/mp4", "video/mov", "video/avi", 'mp4'];

    const onDrop = useCallback((acceptedFiles: File[]) => {
        const formData = new FormData();
        const hasVideo = fileListFromServer?.some((f) => videoTypes.includes(f.format));
        for (const file of acceptedFiles) {
            const isImage = imageTypes.includes(file.type);
            const isVideo = videoTypes.includes(file.type);
            // ✅ Validate Type
            if (!isImage && !isVideo) {
                message.error("Nur JPG/PNG Bilder oder MP4/MOV/AVI Videos sind erlaubt.");
                return;
            }
            // ✅ Allow only one video
            if (isVideo && hasVideo) {
                message.error("Es ist nur ein Video erlaubt.");
                return;
            }
            // ✅ Validate Size
            if (isVideo && file.size / 1024 / 1024 > MAX_VIDEO_SIZE_MB) {
                message.error("Das Video muss kleiner als 100 MB sein.");
                return;
            }
            if (isImage && file.size / 1024 / 1024 > MAX_IMAGE_SIZE_MB) {
                message.error("Das Bild muss kleiner als 4 MB sein.");
                return;
            }
            formData.append('photos', (file as any).originFileObj || file);
        }
        if (formData.has('photos')) {
            requestsAPI.addRequestPhoto(Number(id), formData)
                .then(() => {
                    dispatch(GetRequestById({requestId: Number(id), withFields: false}));
                });
        }
    }, [fileListFromServer]); // eslint-disable-line

    const handleRemoveFile = (photoId: string) => {
        requestsAPI.removePhotoById(Number(photoId))
            .then(() => {
                dispatch(GetRequestById({requestId: Number(id), withFields: false}));
            })
    };

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: {
            "image/jpeg": [],
            "image/png": [],
            "video/mp4": [],
            "video/mov": [],
            "video/avi": [],
        },
        multiple: true,
    });


    const onOpenViewMode = (index: number) => {
        setIsViewerOpen(true)
        setCurrentImageIndex(index)
    }

    const onCloseRequest = () => {
        navigate('/')
    }

    const handleConfirm = (id: number) => {
        onDeleteRequest(id);
    };
    const handleConfirmComment = (id: number) => {
        onDeleteRequestComment(id);
    };
    const onDeleteRequestComment = (commentId: number) => {
        requestsAPI.removeRequestComment(commentId)
            .then(() => {
                dispatch(GetRequestById({requestId: Number(id), withFields: true}))
            })
    }

    const onHideAndShowComment = (comment: {
        access_type: any;
        id: number;
        request_id: number;
        comment_text: string;
        date_created: string;
        user_id: number;
        is_active: boolean
        username: string
    }) => {
        const commentForUpdate = {
            request_id: Number(id),
            comment_text: comment.comment_text,
            access_type: comment.access_type,
            is_active: !comment.is_active
        }
        requestsAPI.updateRequestComment(comment.id, commentForUpdate)
            .then(() => {
                dispatch(GetRequestById({requestId: Number(id), withFields: true}))
            })
    }


    return (
        <div>
            <Header/>
            {
                isRequestLoading
                ?
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        flexDirection: 'column'
                    }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#1F553B' }} spin />} />
                        <span style={{
                            marginTop: '25px'
                        }}>Die Anforderungsdaten werden geladen. Bitte warten Sie.
</span>
                    </div>
                    :
                    <div className={s.inner}>
                        <h1 className={s.inner__title}>{requestTitle}</h1>
                        <div className={s.backLink} onClick={() => navigate('/')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M14 7L9 12L14 17" stroke="#667085" strokeWidth="2" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>
                            <span>Zurück</span>
                        </div>
                        {
                            isViewerOpen
                            &&
                            <ImagesModal
                                images={requestFields?.photos!!}
                                visible={isModalVisible}
                                onClose={onImagesModalClose}
                                isViewerOpen={isViewerOpen}
                                setIsViewerOpen={(isViewerOpen) => setIsViewerOpen(isViewerOpen)}
                                index={currentImageIndex}
                            />
                        }
                        <div className={`${s.form} requestsForm`}>
                            <div className={s.form__row}>
                                <label>Titel</label>
                                <Input placeholder={'Titel eingeben'}
                                       value={requestFields!?.title}
                                       onChange={(e) => onFormInputChange(e, 'title')}/>
                                {requestFields?.title === '' && fieldsWithError &&
                                    <p className={s.form__error}>Bitte Titel eingeben!</p>}
                            </div>
                            <div className={s.form__row}>
                                <label>Emotion</label>
                                <Select
                                    placeholder="Emotion auswählen"
                                    value={iconTypesOptions.find((o) => Number(o.value) === Number(requestFields!?.icon_type.id))!?.label}
                                    onChange={(value) => onFormSelectChange(value, 'icon_type.id')}
                                    style={{width: '100%'}}
                                    options={iconTypesOptions}
                                    allowClear={true}
                                />
                                {requestFields!?.icon_type.id === undefined && fieldsWithError &&
                                    <p className={s.form__error}>Bitte Emotion auswählen!</p>}
                            </div>
                            <div className={s.form__row}>
                                <label>Status</label>
                                <Select
                                    placeholder="Status auswählen"
                                    value={statusOptions.find((o) => o.value === requestFields!?.status.id)!?.label}
                                    onChange={(value) => onFormSelectChange(value, 'status.id')}
                                    style={{width: '100%'}}
                                    options={statusOptions}
                                    allowClear={true}
                                />
                                {requestFields!?.status.id === undefined && fieldsWithError &&
                                    <p className={s.form__error}>Bitte Status auswählen!</p>}
                            </div>
                            <div className={s.form__row}>
                                <label>Vorname</label>
                                <Input placeholder={'Geben Sie den Vornamen ein'}
                                       value={requestFields!?.user_first_name}
                                       onChange={(e) => onFormInputChange(e, 'user_first_name')}/>
                                {requestFields?.user_first_name === '' && fieldsWithError &&
                                    <p className={s.form__error}>Bitte geben Sie den Vornamen ein!</p>}
                            </div>
                            <div className={s.form__row}>
                                <label>Nachname</label>
                                <Input placeholder={'Geben Sie den Nachnamen ein'}
                                       value={requestFields!?.user_last_name}
                                       onChange={(e) => onFormInputChange(e, 'user_last_name')}/>
                            </div>
                            <div className={s.form__row}>
                                <label>E-Mail</label>
                                <Input placeholder={'Geben Sie Ihre E-Mail-Adresse ein'}
                                       value={requestFields!?.user_email}
                                       onChange={(e) => onFormInputChange(e, 'user_email')}/>
                            </div>
                            <div className={s.form__row}>
                                <label>Telefonnummer</label>
                                <Input placeholder={'Geben Sie die Telefonnummer ein'}
                                       value={requestFields!?.user_phone}
                                       onChange={(e) => onFormInputChange(e, 'user_phone')}/>
                            </div>
                            <div className={s.form__row}>
                                <label>Kategorie</label>
                                <Select
                                    placeholder="Kategorie auswählen"
                                    value={topicOptions.find((o) => o.value === requestFields!?.topic.id)!?.label}
                                    onChange={(value) => onFormSelectChange(value, 'topic.id')}
                                    style={{width: '100%'}}
                                    options={topicOptions}
                                    allowClear={true}
                                />
                                {requestFields!?.topic.id === undefined && fieldsWithError &&
                                    <p className={s.form__error}>Bitte Kategorie auswählen!</p>}
                            </div>
                            <div className={s.form__row}>
                                <label>Beschreibung</label>
                                <TextArea placeholder={'Geben Sie eine Beschreibung ein'}
                                          style={{
                                              minHeight: '100px'
                                          }}
                                          value={requestFields!?.description}
                                          onChange={(e) => onFormInputChange(e, 'description')}/>
                                {requestFields?.description === '' && fieldsWithError &&
                                    <p className={s.form__error}>Bitte Beschreibung eingeben!</p>}
                            </div>
                            <div className={s.form__row}>
                                <label>Standort</label>
                                <Input placeholder={'Geben Sie den Standort ein'}
                                       value={`${requestFields!?.district !== null ? requestFields!?.district : ''} ${requestFields!?.street !== null ? requestFields!?.street : ''} ${requestFields!?.house_no !== null ? requestFields!?.house_no : ''}`}
                                       onChange={(e) => onFormInputChange(e, 'title')}
                                       disabled={true}
                                />
                            </div>
                            <div className={s.form__row}>
                                <label>District</label>
                                <Select
                                    placeholder="District auswählen"
                                    value={districtsOptions.find((o) => o.value === requestFields!?.district)!?.label}
                                    onChange={(value) => onFormSelectChange(value, 'district')}
                                    style={{width: '100%'}}
                                    options={districtsOptions}
                                    allowClear={true}
                                    showSearch={true}
                                />
                            </div>
                            <div className={s.form__row}>
                                <label>Quarter</label>
                                <Select
                                    placeholder="Quarter auswählen"
                                    value={quartersOptions.find((o) => o.value === requestFields!?.quarter)!?.label}
                                    onChange={(value) => onFormSelectChange(value, 'quarter')}
                                    style={{width: '100%'}}
                                    options={quartersOptions}
                                    allowClear={true}
                                    showSearch={true}
                                />
                            </div>
                            <div className={s.form__row}>
                                <label>Aktiv</label>
                                <Switch
                                    checkedChildren="Aktiv"
                                    unCheckedChildren="Inaktiv"
                                    value={requestFields?.is_active}
                                    onChange={(e) => onFormInputChange(e, 'is_active')}
                                />
                            </div>
                            {
                                isMapShown
                                &&
                                <div style={{
                                    marginTop: '32px',
                                    borderRadius: '12px'
                                }}>
                                    <MapForRequestPoint
                                        geometry={
                                            {
                                                type: requestFields!?.location !== null ? requestFields!?.location.type : requestFields!?.location_type,
                                                coordinates: requestFields!?.location !== null
                                                    ? requestFields!?.location.type === 'Point'
                                                        ? requestFields!?.location.coordinates.point
                                                        : requestFields!?.location.type === 'Polygon'
                                                            ? requestFields!?.location.coordinates.polygon[0]
                                                            : requestFields!?.location.coordinates.line
                                                    : [],
                                                districtKey: requestFields!?.district!!
                                            }
                                        }
                                    />
                                </div>
                            }
                            <div className={s.media}>
                                <p className={s.media__title}>Medienblock</p>
                                <div>
                                    <div>
                                        {/* ✅ File Preview List */}
                                        <div style={{marginTop: 10, display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                                            {
                                                fileListFromServer!?.length
                                                &&
                                                <ImageSorter
                                                    id={id}
                                                    onOpenViewMode={onOpenViewMode}
                                                    handleRemoveFile={handleRemoveFile}
                                                />
                                            }
                                            <div
                                                {...getRootProps()}
                                                style={{
                                                    border: "2px dashed #ccc",
                                                    padding: "5px",
                                                    borderRadius: "2px",
                                                    cursor: "pointer",
                                                    background: isDragActive ? "#f0f0f0" : "white",
                                                    width: '171px',
                                                    height: '171px',
                                                    display: 'inline-block',
                                                    textAlign: 'center',
                                                    color: '#000',
                                                    position: 'relative'
                                                }}
                                                className={s.uploader}
                                            >
                                                <div className={s.fileLoader}>
                                                    <input {...getInputProps()} />
                                                    {isDragActive ? (
                                                        <p style={{fontSize: "14px"}}>Legen Sie die Dateien hier ab ...</p>
                                                    ) : (
                                                        <p style={{fontSize: "14px"}}>
                                                            {fileListFromServer!?.some((f: any) => videoTypes.includes(f.type))
                                                                ? "Foto hochladen"
                                                                : "Video/Foto hochladen"}
                                                        </p>
                                                    )}
                                                    <div style={{fontSize: "1rem", marginTop: '10px'}}>+</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                {
                                    requestFields!?.comments && requestFields!?.comments.length
                                        ?
                                        <div>
                                            <p className={s.commentsTitle}>Kommentare</p>
                                            {
                                                requestFields.comments.map((c) => {
                                                    return(
                                                        <div className={s.comments}>
                                                            <div className={s.comment}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    width: '100%'
                                                                }}>
                                                                    <div className={s.comment__header}>
                                                                        <img src={avatar} alt="avatar"/>
                                                                        <p>{c.username}</p>
                                                                    </div>
                                                                    <div className={s.comment__btns}>
                                                                        <Popconfirm
                                                                            title="Löschen Sie diesen Kommentar?"
                                                                            description="Diese Aktion kann nicht rückgängig gemacht werden."
                                                                            onConfirm={() => handleConfirmComment(c.id)}
                                                                            okText="Ja"
                                                                            cancelText="Nein"
                                                                            okType="danger"
                                                                        >
                                                                            <button>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                    <path d="M2.5 5.00033H4.16667M4.16667 5.00033H17.5M4.16667 5.00033V16.667C4.16667 17.109 4.34226 17.5329 4.65482 17.8455C4.96738 18.1581 5.39131 18.3337 5.83333 18.3337H14.1667C14.6087 18.3337 15.0326 18.1581 15.3452 17.8455C15.6577 17.5329 15.8333 17.109 15.8333 16.667V5.00033H4.16667ZM6.66667 5.00033V3.33366C6.66667 2.89163 6.84226 2.46771 7.15482 2.15515C7.46738 1.84259 7.89131 1.66699 8.33333 1.66699H11.6667C12.1087 1.66699 12.5326 1.84259 12.8452 2.15515C13.1577 2.46771 13.3333 2.89163 13.3333 3.33366V5.00033M8.33333 9.16699V14.167M11.6667 9.16699V14.167"
                                                                                          stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                </svg>
                                                                            </button>
                                                                        </Popconfirm>
                                                                        {
                                                                            c.is_active
                                                                                ?
                                                                                <button onClick={() => onHideAndShowComment(c)}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                                        <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#667085"
                                                                                              stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                                                                              stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                    </svg>
                                                                                </button>
                                                                                :
                                                                                <button onClick={() => onHideAndShowComment(c)}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                                        <g clip-path="url(#clip0_670_7248)">
                                                                                            <path d="M9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94Z" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </g>
                                                                                        <defs>
                                                                                            <clipPath id="clip0_670_7248">
                                                                                                <rect width="24" height="24" fill="white"/>
                                                                                            </clipPath>
                                                                                        </defs>
                                                                                    </svg>
                                                                                </button>

                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div dangerouslySetInnerHTML={{
                                                                    __html: c.comment_text,
                                                                }} className={s.commentContent}></div>
                                                                <p className={s.commentDate}>{c.date_created}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        :
                                        null

                                }
                            </div>
                            <div className={s.buttons}>
                                <Popconfirm
                                    title="Diese Anfrage löschen?"
                                    description="Diese Aktion kann nicht rückgängig gemacht werden."
                                    onConfirm={() => handleConfirm(requestFields?.id!!)}
                                    okText="Ja"
                                    cancelText="Nein"
                                    okType="danger"
                                >
                                    <button className={s.deleteBtn}>Löschen</button>
                                </Popconfirm>
                                <button className={s.cancelBtn} onClick={onCloseRequest}>Abbrechen</button>
                                <Button loading={loading} className={s.saveBtn} onClick={onSaveRequest}>Speichern</Button>
                            </div>
                        </div>
                    </div>
            }

        </div>
    );
};

export default Request;